
import EmpowerEveryManager from "../solutions/EmpowerEveryManager";

export { Page }

function Page() {
  return <EmpowerEveryManager />;
}
